// Dashboard Actions
import { createAction, props } from '@ngrx/store';
import { DeviceRow } from '../../services/device.service';
import { DashboardFilters, SortKey, SortDirection } from './dashboard.state';

// Load Dashboard
export const loadDashboard = createAction(
  '[Dashboard] Load Dashboard',
  props<{ page?: number; pageSize?: number; query?: string }>()
);
export const loadDashboardSuccess = createAction(
  '[Dashboard] Load Dashboard Success',
  props<{
    rows: DeviceRow[];
    total: number;
    pageSize: number;
    page: number;
    hasMore: boolean;
    nextCursor: string | null;
  }>()
);
export const loadDashboardFailure = createAction(
  '[Dashboard] Load Dashboard Failure',
  props<{ error: string }>()
);

// Refresh Dashboard
export const refreshDashboard = createAction('[Dashboard] Refresh Dashboard');
export const refreshDashboardSuccess = createAction(
  '[Dashboard] Refresh Dashboard Success',
  props<{
    rows: DeviceRow[];
    total: number;
    pageSize: number;
    page: number;
    hasMore: boolean;
    nextCursor: string | null;
  }>()
);
export const refreshDashboardFailure = createAction(
  '[Dashboard] Refresh Dashboard Failure',
  props<{ error: string }>()
);

// Load Device Types
export const loadDeviceTypes = createAction('[Dashboard] Load Device Types');
export const loadDeviceTypesSuccess = createAction(
  '[Dashboard] Load Device Types Success',
  props<{ deviceTypeMap: Record<string, string> }>()
);
export const loadDeviceTypesFailure = createAction(
  '[Dashboard] Load Device Types Failure',
  props<{ error: string }>()
);

// Pagination
export const setPage = createAction(
  '[Dashboard] Set Page',
  props<{ page: number }>()
);
export const setPageSize = createAction(
  '[Dashboard] Set Page Size',
  props<{ pageSize: number }>()
);
export const nextPage = createAction('[Dashboard] Next Page');
export const previousPage = createAction('[Dashboard] Previous Page');

// Search
export const setSearchQuery = createAction(
  '[Dashboard] Set Search Query',
  props<{ query: string }>()
);
export const applySearch = createAction('[Dashboard] Apply Search');
export const clearSearch = createAction('[Dashboard] Clear Search');

// Filters
export const setFilter = createAction(
  '[Dashboard] Set Filter',
  props<{ key: keyof DashboardFilters; value: string }>()
);
export const setFilters = createAction(
  '[Dashboard] Set Filters',
  props<{ filters: Partial<DashboardFilters> }>()
);
export const clearFilters = createAction('[Dashboard] Clear Filters');
export const applyFilters = createAction('[Dashboard] Apply Filters');

// Update filter options (derived from loaded rows)
export const updateFilterOptions = createAction(
  '[Dashboard] Update Filter Options',
  props<{
    hubOptions: string[];
    environmentOptions: string[];
    deviceTypeOptions: string[];
  }>()
);

// Sorting
export const setSort = createAction(
  '[Dashboard] Set Sort',
  props<{ sortKey: SortKey; sortDirection: SortDirection }>()
);
export const toggleSort = createAction(
  '[Dashboard] Toggle Sort',
  props<{ sortKey: SortKey }>()
);
export const clearSort = createAction('[Dashboard] Clear Sort');

// Update filtered rows (after filter/sort changes)
export const setFilteredRows = createAction(
  '[Dashboard] Set Filtered Rows',
  props<{ filteredRows: DeviceRow[] }>()
);

// Clear error
export const clearError = createAction('[Dashboard] Clear Error');
